export default {
  brand: {
    leninka: "Ленинка",
    artIp: "Арт IP",
    digitalEnv: "Цифровая экосистема от «Ленинка Арт»",
    digitalEnvShort: "Цифровая экосистема от «Ленинка Арт»",
  },
  nav: {
    home: "Главная",
    profile: "Профиль",
    events: "Мероприятия",
    projects: "Проекты",
    deposit: "Депонирование",
    admin: "Администрирование",
    contacts: "Контакты",
    about: "О нас",
    login: "Войти",
    loginMobile: "Войти / Профиль",
    logout: "Выйти",
    openMenu: "Открыть меню",
    closeMenu: "Закрыть меню",
    partnersGroup: "Логотипы партнёров проекта",
    partnerAilaAlt: "Логотип AILA",
    partnerLeninkaArtAlt: "Логотип проекта «Ленинка Арт»",
    eventsMenuAria: "Меню раздела «Мероприятия»",
    eventsMenuPanelHeading: "Афиша и управление мероприятиями",
    eventsMenu: {
      all: "Все мероприятия",
      created: "Мои мероприятия",
      moderation: "Модерация мероприятий",
      registrations: "Модерация участников",
    },
    projectsMenuAria: "Меню раздела «Проекты»",
    projectsMenuPanelHeading: "Проекты и акселератор",
    projectsMenu: {
      all: "Все проекты",
      portal: "Портал проектов",
    },
  },
  footer: {
    portalTitle: "Экосистема",
    infoTitle: "Информация",
    aboutLibrary: "О нас",
    contacts: "Контакты",
    personalDataConsent: "Согласие на обработку персональных данных",
    personalDataProcessingPolicy: "Политика обработки персональных данных",
    tagline:
      "Помогаем творцам и командам развивать идеи, запускать проекты, находить единомышленников и выстраивать индивидуальную траекторию роста",
    copyright: "© 2026 Ленинка Арт IP. Все права защищены.",
    terms: "Пользовательское соглашение",
    socialVk: "ВКонтакте",
    socialTelegram: "Telegram",
  },
  common: {
    all: "Все",
    more: "Подробнее",
    openLink: "Открыть",
    register: "Зарегистрироваться",
    close: "Закрыть",
    cancel: "Отмена",
    searchCatalog: "Поиск по каталогу...",
    charLimit: "Превышен лимит символов",
    or: "или",
    loading: "Загрузка...",
    opensInNewTab: "откроется в новой вкладке",
    skipToContent: "Перейти к содержимому",
    pager: {
      navigation: "Пагинация",
      previousPage: "Предыдущая страница",
      nextPage: "Следующая страница",
    },
    datePicker: {
      prevMonth: "Предыдущий месяц",
      nextMonth: "Следующий месяц",
      clearDate: "Очистить дату",
      selectDay: "День",
      selectMonth: "Месяц",
      selectYear: "Год",
      selectPlaceholder: "—",
      calendarBirth: "Выбор даты рождения",
      calendarAchievement: "Выбор даты достижения",
      calendarWorkCreation: "Выбор даты создания произведения",
    },
    timePicker: {
      hours: "Часы",
      minutes: "Минуты",
    },
    table: {
      sortAria: "Сортировать: {{column}}, {{direction}}",
      sortDirectionAsc: "по возрастанию",
      sortDirectionDesc: "по убыванию",
      sortDirectionNone: "без сортировки",
    },
  },
  breadcrumbs: {
    home: "Главная",
    events: "Мероприятия",
    projects: "Проекты",
    deposits: "Депонирование",
    details: "Детали",
  },
  home: {
    hero: {
      badge: "Ленинка",
      badgeAccent: "Арт IP",
      titleLine1: "Знания.",
      titleLine2: "Творчество.",
      titleLine3: "Будущее.",
      subtitle:
        "Помогаем творцам и командам развивать идеи, запускать проекты, находить единомышленников и выстраивать индивидуальную траекторию роста",
      quickEvents: "Мероприятия",
      quickDeposit: "Депонирование",
      quickProjects: "Проекты",
      statProjects: "проектов",
      statYear: "форматов участия",
      statReaders: "активных пользователей",
      imageAlt: "Ленинская библиотека",
      scrollToQuickLinks: "Перейти к быстрым ссылкам",
    },
    directions: {
      kicker: "Что мы предлагаем",
      title1: "ОСНОВНЫЕ",
      title2: "НАПРАВЛЕНИЯ",
      eventsTitle: "Мероприятия",
      eventsDesc:
        "Лекции, выставки, мастер-классы и другие события экосистемы Ленинка Арт IP для авторов, исследователей и креативных команд.",
      projectsTitle: "Проекты",
      projectsDesc:
        "Создавайте исследовательские и творческие проекты, получайте оценки сообщества и поддержку экспертов.",
      depositTitle: "Депонирование",
      depositDesc:
        "Официальная регистрация и защита авторских прав на ваши произведения в фондах РГБ.",
    },
    events: {
      kicker: "Афиша",
      title: "Мероприятия",
      allLink: "Все мероприятия",
      empty: "Ближайших мероприятий пока нет",
    },
    projects: {
      kicker: "Депонирование",
      title: "Публичный реестр",
      allLink: "Все записи",
    },
    cta: {
      titleLine1: "Станьте частью сообщества",
      titleLine2: "",
      subtitle:
        "Регистрируйтесь, чтобы участвовать в событиях, создавать проекты, развивать портфолио и использовать возможности платформы.",
      register: "Зарегистрироваться",
      imageAlt: "Присоединяйтесь",
    },
  },
  aboutPage: {
    documentTitle: "О нас — Ленинка Арт IP",
    kicker: "Экосистема",
    title: "О нас",
    lead:
      "«Ленинка Арт IP» — цифровая платформа, созданная АНО «ЛенинкаАрт». Здесь творцы, исследователи и креативные команды находят события, запускают проекты и развивают компетенции в сфере культуры и технологий.",
    childSiteTitle: "Что такое «Ленинка Арт IP»",
    childSiteBody1:
      "Портал создан для удобной работы онлайн: регистрация на события, подача проектов в акселератор и взаимодействие с профессиональным сообществом. Он дополняет офлайн-программы творческой резиденции «Ленинка Арт», перенося ключевые процессы в цифровую среду.",
    missionTitle: "Миссия",
    missionText: "Развиваем пространство будущего и ядро экспертизы по цифровым решениям в сфере культуры.",
    valuesTitle: "Ценности",
    values: {
      elite: "Формирование интеллектуальной элиты",
      trends: "Исследование трендов",
      environment: "Создание среды для специалистов будущего",
    },
    orgTeamTitle: "Команда АНО «Ленинка Арт»",
    orgTeamIntro:
      "В команду входят руководители и специалисты, отвечающие за стратегию, программную деятельность, юридическое сопровождение, медиа, архитектуру цифровых сервисов и работу с данными.",
    team: {
      director: "Анна Афанасьева — генеральный директор",
      exec: "Людмила Алиева — исполнительный директор",
      program: "Матвей Навдаев — программный директор",
      accountant: "Людмила Коваленко — главный бухгалтер",
      legal: "Сергей Таранов — главный юрист",
      neurofest: "Ольга Милосердова — руководитель проекта «Нейрофест»",
      media: "Ксения Узунова — руководитель медиаслужбы",
      digital: "Роман Ильин — архитектор цифровых сервисов",
      data: "Виктория Арабина — архитектор озера данных",
    },
    orgTeamCta: "Полный состав команды на leninkaart.ru",
    expertCouncilTitle: "Экспертный совет",
    expertCouncilIntro:
      "При АНО «Ленинка Арт» действует экспертный совет, объединяющий лидеров из сферы искусственного интеллекта, банковского сектора, телекоммуникаций, культуры и науки. Совет помогает формировать стратегию проекта и обеспечивает связь с индустрией.",
    experts: {
      kraynov: {
        name: "Александр Крайнов",
        role: "Директор по развитию технологий ИИ, Яндекс",
      },
      dimitrov: {
        name: "Денис Димитров",
        role: "Управляющий директор по исследованию данных, Sber AI",
      },
      vorobeva: {
        name: "Валерия Воробьева",
        role: "Генеральный директор Альянса в сфере ИИ",
      },
      mashkovtsev: {
        name: "Борис Машковцев",
        role: "Генеральный директор «Союзмультфильм»",
      },
      voloshin: {
        name: "Станислав Волошин",
        role: "Зам. председателя правления Фонда «Сколково»",
      },
      shubin: {
        name: "Михаил Шубин",
        role: "Зам. генерального директора — директор по цифровизации РГБ",
      },
      markov: {
        name: "Дмитрий Марков",
        role: "Исполнительный директор MTS AI, генеральный директор VisionLabs",
      },
      vaganov: {
        name: "Даниил Ваганов",
        role: "Руководитель ML-отдела, Positive Technologies",
      },
    },
    expertCouncilMore:
      "В совет также входят представители ВТБ, Альфа-Банка, Дом.РФ, Росатома, МАРХИ и других организаций.",
    expertCouncilCta: "Полный состав — на официальной странице.",
    ctaContacts: "Написать нам",
  },
  contactsPage: {
    kicker: "Связь с нами",
    title: "Контакты",
    writeUs: "Напишите нам",
    sentTitle: "Сообщение отправлено!",
    sentHint: "Мы ответим в течение 1–2 рабочих дней.",
    name: "Имя",
    email: "Email",
    subject: "Тема обращения",
    message: "Сообщение",
    send: "Отправить сообщение",
    address: "Адрес",
    phone: "Телефон",
    emailBlock: "Email",
    officialPages: "Официальные страницы",
    siteLabel: "Сайт АНО «ЛенинкаАрт»",
    socialNetworks: "Социальные сети",
    mapTitle: "Карта РГБ",
    subjects: {
      general: "Общий вопрос",
      events: "Мероприятия",
      deposit: "Депонирование",
      tech: "Технические вопросы",
      coop: "Сотрудничество",
    },
  },
  legalPages: {
    agreementTitle: "Пользовательское соглашение — Ленинка Арт IP",
    personalTitle: "Согласие на обработку персональных данных — Ленинка Арт IP",
    privacyTitle: "Политика обработки персональных данных — Ленинка Арт IP",
    projectConsentStubs: {
      personalData: {
        title: "Согласие на обработку персональных данных (проект) — Ленинка Арт IP",
        body: "Текст документа готовится и будет опубликован позже. Пока вы можете ознакомиться с общими условиями на сайте или вернуться к заполнению заявки.",
      },
      ipRights: {
        title: "Согласие на передачу прав на интеллектуальную собственность (проект) — Ленинка Арт IP",
        body: "Текст документа готовится и будет опубликован позже. Пока вы можете вернуться к заполнению заявки.",
      },
      documentsReadiness: {
        title: "Подтверждение готовности документов (проект) — Ленинка Арт IP",
        body: "Текст документа готовится и будет опубликован позже. Пока вы можете вернуться к заполнению заявки.",
      },
      photoVideo: {
        title: "Согласие на фото- и видеосъёмку (проект) — Ленинка Арт IP",
        body: "Текст документа готовится и будет опубликован позже. Пока вы можете вернуться к заполнению заявки.",
      },
    },
  },
  notFound: {
    title: "Страница не найдена",
    hint: "Проверьте адрес или вернитесь на главную.",
    backHome: "На главную",
  },
}
